/* @flow */
import gql from 'graphql-tag';
import {fragments as breadcrumbFragments} from '../components/Breadcrumb/Breadcrumb';
import {fragments as hitCollectionFragments} from '../components/HitCollection/HitCollection';
import {fragments as mapFragments} from '../components/Map/Map';
import {fragments as pagerFragments} from '../components/Pager/Pager';
import {fragments as destinationMessage} from '../components/SearchBannerContainer/destinationMessage';
import {fragments as filterCountsFragments} from '../../universal/queries/filteredCountQuery';
import {fragments as expandedGroupsFragments} from '../components/ExpandedGroups/ExpandedGroups';
import {fragments as analyticsDataLayerFragments} from '../components/AnalyticsDataLayer/AnalyticsDataLayer';
import {fragments as searchTermCarouselFragments} from '../components/SearchTermCarousel/SearchTermCarousel';
import {fragments as seoContentFragment} from '../components/SeoContent/SeoContent';
import {fragments as internalToolsFragments} from '../components/InternalTools/InternalTools';
import transformSrsParamsToGts from '../../server/graphql/transformers/transformSrsParamsToGts';
import {srsParams as getSrsParams} from '../utils/searchParamsUtils';
import type {SearchParamsType} from '../reducers/searchParams';
import {querySelectionSet} from './searchQuery';

export const searchRequestQueryVariables = (params: SearchParamsType) => {
    const srsParams = getSrsParams(params);
    return {
        request: transformSrsParamsToGts(srsParams)
    };
};

export const SEARCH_REQUEST_QUERY_NAME = 'SearchRequestQuery';

const searchRequestQuery = gql`
    query ${SEARCH_REQUEST_QUERY_NAME}($request: SearchResultRequest!, $gtsQuery: Boolean!) {
        results: search(request: $request) {
            ${querySelectionSet}
            ...BreadcrumbSearchResult
            ...DestinationMessageSearchResult
            ...FilterCountsSearchResult
            ...HitCollectionSearchResult
            ...ADLSearchResult
            ...MapSearchResult
            ...ExpandedGroupsSearchResult
            ...PagerSearchResult
            ...SearchTermCarouselSearchResult
            ...SeoContentSearchResult
            ...InternalToolsSearchResult
        }
        ...RequestMarkerFragment
    }
    ${breadcrumbFragments.searchResult}
    ${hitCollectionFragments.searchResult}
    ${expandedGroupsFragments.searchResult}
    ${filterCountsFragments.searchResult}
    ${mapFragments.searchResult}
    ${pagerFragments.searchResult}
    ${destinationMessage.searchResult}
    ${analyticsDataLayerFragments.searchResult}
    ${analyticsDataLayerFragments.query}
    ${searchTermCarouselFragments.searchResult}
    ${seoContentFragment.searchResult}
    ${internalToolsFragments.searchResult}
`;

export default searchRequestQuery;
